import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import { SectionLayoutContainer } from './section-layout.container';
import { IdentificationVerificationRouter } from './identity-verification/case-router';
import { SendReportRouter } from './send-report/case-router';
import { CredentialVerificationRouter } from './credential-verification/case-router';
import { Helmet } from 'react-helmet';

interface RequestListPageProps {}

export const RequestListPage: FC<RequestListPageProps> = () => {
  return (
    <>
      <Helmet>
        <title>Case</title>
      </Helmet>
      <Routes>
        <Route path="" element={<SectionLayoutContainer />}>
          <Route path="id-verification/:caseId/*" element={<IdentificationVerificationRouter />} />
          <Route path="credential-verification/:caseId/*" element={<CredentialVerificationRouter />} />
          <Route path="send-report/:caseId/*" element={<SendReportRouter />} />
        </Route>
      </Routes>
    </>
  );
};
